import { render, staticRenderFns } from "./topbarGoRefsList.vue?vue&type=template&id=170b0c02&"
import script from "./topbarGoRefsList.vue?vue&type=script&lang=js&"
export * from "./topbarGoRefsList.vue?vue&type=script&lang=js&"
import style0 from "./topbarGoRefsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports